import { isUnknownVintage } from '@helpers/vintage';
import { grapeUrl } from '@helpers/vivinoUrls';
import { Anchor } from '@vivino/js-web-common';
import React from 'react';
import t from 'vivino-js/translationString';
import { Grape } from 'vivino-ui/icons/WineFacts';

const TRANSLATION_PATH = 'components.shared.wine_summary';
const TRANSLATIONS = {
  grapes: `${TRANSLATION_PATH}.grapes`,
  grape_percentage: `${TRANSLATION_PATH}.grape_percentage`,
};

export const getGrapesFact = (vintage, translationFunc = t) => {
  // for vintage wine, use grape_composition if it exists
  let grapes = vintage.grapes || [];
  const compositionEntries = Object.entries(vintage.grape_composition || {});
  if (!isUnknownVintage(vintage) && grapes.length > 0 && compositionEntries.length > 0) {
    const ID_TO_GRAPE = grapes.reduce((memo, grape) => {
      memo[grape.id] = grape;
      return memo;
    }, {});
    const percentageSum = compositionEntries.reduce((sum, entry) => sum + entry[1], 0);
    if (percentageSum === 100) {
      const sortedCompositionEntries = compositionEntries
        .filter((entry) => entry[1] > 0)
        .sort((entry1, entry2) => entry2[1] - entry1[1]);
      return {
        key: 'grapes',
        icon: Grape,
        headerLabel: translationFunc(TRANSLATIONS.grapes),
        values: sortedCompositionEntries.map(([grapeId, percentage]) => ({
          name: translationFunc(TRANSLATIONS.grape_percentage, {
            percentage,
            grape: (
              <Anchor key={grapeId} href={grapeUrl({ grape: ID_TO_GRAPE[grapeId] })}>
                {ID_TO_GRAPE[grapeId].name}
              </Anchor>
            ),
          }),
        })),
      };
    }
  }

  if (grapes.length === 0) {
    // if no vintage.grapes, fallback to wine.grapes
    grapes = vintage.wine?.grapes || [];
  }
  if (grapes.length > 0) {
    return {
      key: 'grapes',
      icon: Grape,
      headerLabel: translationFunc(TRANSLATIONS.grapes),
      values: grapes.map((grape) => ({
        name: grape.name,
        url: grapeUrl({ grape }),
      })),
    };
  }
  return null;
};
